import { ReactNode } from "react";
import { Flex, Text, Badge, AccordionItem, AccordionPanel, AccordionButton, AccordionIcon } from "@chakra-ui/react";

interface IFilterCategoryItemProps {
    children: ReactNode;
    title: string;
    badgeInfo?: string;
}
export const FilterCategoryItem = ({ children, title, badgeInfo }: IFilterCategoryItemProps) => {
    return (
        <AccordionItem
            border="none"
            px={3}
            backgroundColor="white"
            sx={{
                ".chakra-collapse": {
                    overflow: "initial!important",
                },
            }}
        >
            <AccordionButton py={3}>
                <Flex alignItems="center">
                    <Text alignSelf="center" fontSize="md">
                        {title}
                    </Text>
                    {badgeInfo && (
                        <Badge ml={1} variant="solid" size="sm" colorScheme="blackAlpha" fontSize={["sm", "xs"]}>
                            {badgeInfo}
                        </Badge>
                    )}
                </Flex>
                <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pt={1} pb={3}>
                {children}
            </AccordionPanel>
        </AccordionItem>
    );
};
